export const VideoContainerName = "universal-media-player";

/**
 * oneplayer refers to deprecated red tiger video player
 * ump refers to universal media player, new video player
 */
export enum VideoPlayerEvent {
  // onePlayer Event
  ContentStart = "contentstart",
  /**
   * ump event
   * fires when play button is clicked
   * If duration !==0 redirected to resume behavior
   */
  Play = "play",
  Pause = "pause",
  /**
   * onePlayer event
   * ump implemented by checking duration !==0 on `play`event
   */
  Resume = "resume",
  /**
   * happens on every second change of the clock
   */
  TimeUpdate = "timeupdate",
  // onePlayer event
  Seek = "seek",
  // ump event
  Seeked = "seeked",
  // onePlayer event
  ContentComplete = "contentcomplete",
  // ump event
  Ended = "ended",
  // oneNote event
  Buffering = "Buffering",
  Error = "error",
  // onePlayer Event
  Mute = "mute",
  // onePlayer Event
  Unmute = "unmute",
  // onePlayer event
  FullscreenEnter = "fullscreenenter",
  // onePlayer event
  FullscreenExit = "fullscreenexit",
  /**
   * onePlayer event
   * ump to support event
   */
  Replay = "replay",
  Ready = "ready",
  /**
   * onePlayer event
   * ump to support event
   */
  ClosedCaptionsChanged = "closedcaptionschanged",
  /**
   * onePlayer event
   * ump to support event
   */
  ClosedCaptionSettingsChanged = "closedcaptionsettingschanged",
  /**
   * onePlayer event
   * ump to support event
   */
  VideoQualityChanged = "videoqualitychanged",
  FullscreenChange = "fullscreenchange",
  /**
   * ump event without a defined behavior
   */
  AudioProcess = "audioprocess",
  /**
   * ump event without a defined behavior
   */
  CanPlay = "canplay",
  /**
   * ump event without a defined behavior
   */
  CanPlayThrough = "canplaythrough",
  /**
   * ump event without a defined behavior
   */
  Complete = "complete",
  /**
   * ump event without a defined behavior
   */
  Emptied = "emptied",
  /**
   * ump event without a defined behavior
   */
  LoadedData = "loadeddata",
  /**
   * ump event without a defined behavior
   */
  LoadStart = "loadstart",
  /**
   * ump event without a defined behavior
   */
  Playing = "playing",
  /**
   * ump event without a defined behavior
   */
  Progress = "progress",
  /**
   * ump event without a defined behavior
   */
  RateChange = "ratechange",
  /**
   * ump event without a defined behavior
   */
  Seeking = "seeking",
  /**
   * ump event without a defined behavior
   */
  Stalled = "stalled",
  /**
   * ump event without a defined behavior
   */
  Suspend = "suspend",
  /**
   * ump event without a defined behavior
   */
  VolumeChange = "volumechange",
  /**
   * ump event without a defined behavior
   */
  Waiting = "waiting",
}

// commented out events are not needed yet. Kept for future reference
export const VideoEventNameToBehavior = new Map<string, number>([
  [VideoPlayerEvent.ContentStart, 240],
  [VideoPlayerEvent.Play, 240],
  [VideoPlayerEvent.Pause, 241],
  [VideoPlayerEvent.Resume, 242],
  [VideoPlayerEvent.TimeUpdate, 243],
  [VideoPlayerEvent.Seek, 244],
  [VideoPlayerEvent.Seeked, 244],
  [VideoPlayerEvent.ContentComplete, 245],
  [VideoPlayerEvent.Ended, 245],
  [VideoPlayerEvent.Buffering, 246],
  [VideoPlayerEvent.Error, 247],
  [VideoPlayerEvent.Mute, 248],
  [VideoPlayerEvent.Unmute, 249],
  [VideoPlayerEvent.FullscreenEnter, 250],
  [VideoPlayerEvent.FullscreenExit, 251],
  [VideoPlayerEvent.Replay, 252],
  [VideoPlayerEvent.Ready, 253],
  [VideoPlayerEvent.ClosedCaptionsChanged, 257],
  [VideoPlayerEvent.ClosedCaptionSettingsChanged, 258],
  [VideoPlayerEvent.VideoQualityChanged, 259],
  [VideoPlayerEvent.FullscreenChange, -1],
  /*
  [VideoPlayerEvent.AudioProcess, -1],
  [VideoPlayerEvent.CanPlay, -1],
  [VideoPlayerEvent.CanPlayThrough, -1],
  [VideoPlayerEvent.Complete, -1],
  [VideoPlayerEvent.Emptied, -1],
  [VideoPlayerEvent.LoadedData, -1],
  [VideoPlayerEvent.LoadStart, -1],
  [VideoPlayerEvent.Playing, -1],
  // too many event triggers, didn't exist in oneplayer
  [VideoPlayerEvent.Progress, -1],
  [VideoPlayerEvent.RateChange, -1],
  [VideoPlayerEvent.Seeking, -1],
  [VideoPlayerEvent.Stalled, -1],
  [VideoPlayerEvent.Suspend, -1],
  [VideoPlayerEvent.VolumeChange, -1],
  [VideoPlayerEvent.Waiting, -1],
  */
]);
